// extracted by mini-css-extract-plugin
export default {"card":"CurrentDay_card__gDITD","cardInner":"CurrentDay_cardInner__mCes4","textInner":"CurrentDay_textInner__NEdJP","weekday":"CurrentDay_weekday__uWKTO"};